import { apiGet, apiPost, apiPut, apiDelete, apiPostForm, apiFetch, apiGetBlob } from "./apiClient";

const BASE = "/transaction-receipts";

function buildQuery(params = {}) {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null || value === "") return;

        // Column filters arrive as arrays; repeat the key so Spring binds a List.
        if (Array.isArray(value)) {
            value.forEach((item) => {
                if (item !== undefined && item !== null && item !== "") {
                    searchParams.append(key, item);
                }
            });
            return;
        }

        searchParams.append(key, value);
    });

    const query = searchParams.toString();
    return query ? `?${query}` : "";
}

export function getTransactionReceiptPermissions() {
    return apiGet(`${BASE}/permissions`);
}

export function getTransactionReceipts(params = {}) {
    return apiGet(`${BASE}${buildQuery(params)}`);
}

export function getTransactionReceiptFilterOptions() {
    return apiGet(`${BASE}/filter-options`);
}

export function getTransactionReceiptDetail(id) {
    return apiGet(`${BASE}/${id}`);
}

export function createTransactionReceipt(payload) {
    return apiPost(BASE, payload);
}

export function updateTransactionReceipt(id, payload) {
    return apiPut(`${BASE}/${id}`, payload);
}

export function deleteTransactionReceipt(id) {
    return apiDelete(`${BASE}/${id}`);
}

export function previewTransactionReceiptExcel(file) {
    const formData = new FormData();
    formData.append("file", file);
    return apiPostForm(`${BASE}/excel/preview`, formData);
}

export function importTransactionReceiptExcel(file) {
    const formData = new FormData();
    formData.append("file", file);
    return apiPostForm(`${BASE}/excel/import`, formData);
}

export function uploadTransactionReceiptFile(id, file) {
    const formData = new FormData();
    formData.append("file", file);
    return apiPostForm(`${BASE}/${id}/receipt`, formData);
}

export function replaceTransactionReceiptFile(id, file) {
    const formData = new FormData();
    formData.append("file", file);
    return apiFetch(`${BASE}/${id}/receipt`, {
        method: "PUT",
        body: formData,
    });
}

export function deleteTransactionReceiptFile(id) {
    return apiDelete(`${BASE}/${id}/receipt`);
}

export function viewTransactionReceiptFile(id) {
    return apiGetBlob(`${BASE}/${id}/receipt`);
}

export function downloadTransactionReceiptFile(id) {
    return apiGetBlob(`${BASE}/${id}/receipt/download`);
}

/** Deletes several rows and their PDF receipts in one call. ADMIN and MODERATOR only. */
export function bulkDeleteTransactionReceipts(ids) {
    return apiPost(`${BASE}/bulk-delete`, { ids });
}
